import Joi from 'joi';

const queryValidator = Joi.object({}).when('.dateType', {
  is: 'DAY',
  then: Joi.object({
    fromDate: Joi.date()
      .required()
      .label('From Date'),
    toDate: Joi.date()
      .min(Joi.ref('fromDate'))
      .message('To Date must be same or after From Date')
      .required()
      .label('To Date')
  }),
  otherwise: Joi.object({
    fromDate: Joi.date()
      .required()
      .label('Month&Year')
  })
});

export default queryValidator;
